import Vue from 'vue';
import Router from 'vue-router';
import Dialogue from '@/layouts/Dialogue';
import Centered from '@/layouts/Centered';
import Profile from '@/components/Profile';
import EditProfile from '@/components/EditProfile';
import Login from '@/components/Login';
import Logout from '@/components/Logout';
import Signup from '@/components/Signup';
import Authorize from '@/components/Authorize';
import AskConsent from '@/components/AskConsent';
import PasswordReset from '@/components/PasswordReset';
import PrivacyNotice from '@/components/PrivacyNotice';
import { isAuthenticated, getConsentDate } from '@/auth';
import { routerMode, privacyNoticeDate } from '@/config';

Vue.use(Router);

const router = new Router({
  mode: routerMode,
  routes: [
    {
      path: '/',
      name: 'Profile',
      components: {
        layout: Dialogue,
        content: Profile,
      },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/edit',
      name: 'EditProfile',
      components: {
        layout: Dialogue,
        content: EditProfile,
      },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/ask-consent',
      name: 'AskConsent',
      components: {
        layout: Dialogue,
        content: AskConsent,
      },
      props: {
        content: route => ({
          redirect: route.query.redirect,
        }),
      },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/authorize',
      name: 'Authorize',
      components: {
        layout: Centered,
        content: Authorize,
      },
      props: {
        content: route => ({
          responsetype: route.query.responsetype,
          callback: route.query.callback,
          payload: route.query.payload,
          prompt: route.query.prompt,
          state: route.query.state,
        }),
      },
      meta: {
        requiresAuth: ({ query }) => query.prompt !== 'none',
        checkConsent: ({ query }) => query.prompt !== 'none',
      },
    },
    {
      path: '/login',
      name: 'Login',
      components: {
        layout: Dialogue,
        content: Login,
      },
      props: {
        content: route => ({
          redirect: route.query.redirect,
        }),
      },
    },
    {
      path: '/reset/:email?',
      name: 'PasswordReset',
      components: {
        layout: Dialogue,
        content: PasswordReset,
      },
      props: { content: true },
    },
    {
      path: '/signup/:email?',
      name: 'Signup',
      components: {
        layout: Dialogue,
        content: Signup,
      },
      props: { content: true },
    },
    {
      path: '/logout',
      name: 'Logout',
      components: {
        layout: Centered,
        content: Logout,
      },
      props: {
        content: route => ({
          callback: route.query.callback,
          state: route.query.state,
        }),
      },
    },
    {
      path: '/privacy-notice',
      name: 'PrivacyNotice',
      components: {
        layout: Dialogue,
        content: PrivacyNotice,
      },
    },
  ],
});

router.beforeResolve((to, from, next) => {
  const result = prop => (typeof prop === 'function' ? prop(to) : prop);
  const mustAuthenticate = to.matched.some(
    record => result(record.meta.requiresAuth));
  const mustConsent = to.matched.some(
    record => result(record.meta.checkConsent));

  if (mustAuthenticate || mustConsent) {
    // this route requires auth or consent, check if logged in
    // if not, redirect to login page.
    return isAuthenticated((authenticated) => {
      if (!authenticated) {
        next({ path: '/login', query: { redirect: to.fullPath } });
      } else if (mustConsent) {
        getConsentDate((date) => {
          // dates in ISO8601 are sortable strings
          if (!date || date < privacyNoticeDate) {
            next({
              path: '/ask-consent',
              query: { redirect: to.fullPath },
            });
          } else {
            next();
          }
        });
      } else {
        next();
      }
    });
  }

  return next(); // make sure to always call next()!
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js